import { defineAsyncComponent } from '../compat/vueCompat';
import { requestDialog } from './requestDialog';
import type { ArchiveBulkRequest } from '@mimir/web/dialogs/archiveBulkDialogRequest';

const ArchiveBulkDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/ArchiveBulkDialog.vue'));

export function showArchiveBulkDialog(req: ArchiveBulkRequest) {
  requestDialog(req, ArchiveBulkDialog);
}
